/* eslint-disable react-hooks/exhaustive-deps */
"use client";

import { useEffect, useState } from "react";
import CarDetailingPackageBlock from "./carDetailingPackageBlock";
import {
  BlockCarDetailingPackageHighlight,
  BlockServiceAddonHighlight,
} from "@/types/schema";
import { CarDetailingAddOnsProps } from "../CarDetailingAddOns";
export interface IpApiResponse {
  ip: string;
  success: boolean;
  type: string;
  continent: string;
  continent_code: string;
  country: string;
  country_code: string;
  region: string;
  region_code: string;
  city: string;
  latitude: number;
  longitude: number;
  is_eu: boolean;
  postal: string;
  calling_code: string;
  capital: string;
  borders: string;
  flag: {
    img: string;
    emoji: string;
    emoji_unicode: string;
  };
  connection: {
    asn: number;
    org: string;
    isp: string;
    domain: string;
  };
  timezone: {
    id: string;
    abbr: string;
    is_dst: boolean;
    offset: number;
    utc: string;
    current_time: string;
  };
  currency: {
    name: string;
    code: string;
    symbol: string;
    plural: string;
    exchange_rate: number;
  };
}

interface CarDetailingPackageBlockLocationLoaderProps {
  isInteriorCarDetailing?: boolean;
  highlightData: BlockCarDetailingPackageHighlight;
  addonData?: BlockServiceAddonHighlight;
  showTitle?: boolean;
  showDescription?: boolean;
  noWrapTabs?: boolean;
  addons?: CarDetailingAddOnsProps;
  showAddons?: boolean;
}
const CarDetailingPackageBlockLocationLoader: React.FC<
  CarDetailingPackageBlockLocationLoaderProps
> = ({
  isInteriorCarDetailing,
  highlightData,
  showDescription = true,
  showTitle = true,
  noWrapTabs = false,
  addons,
  showAddons = true,
}) => {
  const [isCanada, setIsCanada] = useState<boolean>(false);
  const getLocationDataFromIp = async () => {
    return await fetch(
      `https://ipwhois.pro?key=${process.env.NEXT_PUBLIC_IP_API}`,
    );
  };

  const initData = async () => {
    const response = await getLocationDataFromIp();
    const data: IpApiResponse = await response.json();
    if (data.success === true) {
      if (data.country_code.toLowerCase().trim().includes("ca")) {
        setIsCanada(true);
      }
    }
  };

  useEffect(() => {
    initData();
  }, []);

  return (
    <CarDetailingPackageBlock
      noWrapTabs={noWrapTabs}
      showTitle={showTitle}
      showDescription={showDescription}
      showAddons={showAddons}
      addons={addons}
      isInteriorCarDetailing={isInteriorCarDetailing}
      highlightData={highlightData}
      isCa={isCanada}
    />
  );
};

export default CarDetailingPackageBlockLocationLoader;
